// extracted by mini-css-extract-plugin
export default {"left_right":"Website_left_right__kGnvi"};